module.exports = nextEvent

function nextEvent (emitter, name) {
  var next = null
  emitter.on(name, function (data) {
    if (!next) return
    var fn = next
    next = null
    fn(data)
  })

  return function (once) {
    next = once
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/next-event/index.js
// module id = 160
// module chunks = 0